/* Show the "added to cart" button overlay when a product is added to cart */
// const addToCartButtons = document.querySelectorAll('.quick-add__submit, .product-form__submit')
// addToCartButtons.forEach((button) => {
//   button.addEventListener('click', () => {
//     const addedToCart = button.querySelector('.added-to-cart')
//     if (addedToCart) {
//       addedToCart.classList.add('visible')
//       setTimeout(() => {
//         addedToCart.classList.remove('visible')
//       }, 3000)
//     }
//   })
// })

const moreInfoButton = document.getElementById('more-info-button')
moreInfoButton.addEventListener('click', () => {
  console.log('Clicked more info')
  document.getElementById('product-description').scrollIntoView({
    behavior: 'smooth'
  })
})
